import request from '../../../../shared/lib/request';
import { RPC } from '../../../../shared/constants';

const riassegnaPratica = (obj) =>
  request({
    url: RPC.GESTIONE_PRATICA,
    method: 'POST',
    data: {
      params: {
        ...obj,
      },
      method: 'riassegna_pratica',
    },
  });

const confermaStipula = (id) =>
  request({
    url: RPC.GESTIONE_PRATICA,
    method: 'POST',
    data: {
      params: {
        pratica: id,
      },
      method: 'conferma_stipula',
    },
  });

const annullaConfermaStipula = (id) =>
  request({
    url: RPC.GESTIONE_PRATICA,
    method: 'POST',
    data: {
      params: {
        pratica: id,
      },
      method: 'annulla_conferma_stipula',
    },
  });

const forzaPraticaNonLiquidabile = (id) =>
  request({
    url: RPC.GESTIONE_STATO_PRATICA,
    method: 'POST',
    data: {
      params: {
        pratica: id,
      },
      method: 'imposta_pratica_conclusa_non_liquidabile',
    },
  });

const forzaPraticaLiquidabile = (id) =>
  request({
    url: RPC.GESTIONE_STATO_PRATICA,
    method: 'POST',
    data: {
      params: {
        pratica: id,
      },
      method: 'imposta_pratica_conclusa_liquidabile',
    },
  });

const getDatiCommissioning = (praticaId) =>
  request({
    url: RPC.GESTIONE_PRATICA,
    method: 'POST',
    data: {
      params: {
        pratica: praticaId,
      },
      method: 'get_dati_commissioning',
    },
  });

const getDatiCommissioningImpresa = (processoImpreseId) =>
  request({
    url: RPC.GESTIONE_PRATICA,
    method: 'POST',
    data: {
      params: {
        processoImprese: processoImpreseId,
      },
      method: 'get_dati_commissioning',
    },
  });

const blocca = (method, praticaId, nota) =>
  request({
    url: RPC.GESTIONE_STATO_PRATICA,
    method: 'POST',
    data: {
      params: {
        pratica: praticaId,
        nota,
      },
      method,
    },
  });

const GestioneAVCeDD = (method, soggettoId, motivazioneId, nota) =>
  request({
    url: RPC.GESTIONE_STATO_PRATICA,
    method: 'POST',
    data: {
      params: {
        soggetto: soggettoId,
        motivazione: motivazioneId,
        nota,
      },
      method,
    },
  });

const confermaSenior = (id, esito, nota) =>
  request({
    url: RPC.GESTIONE_PRATICA,
    method: 'POST',
    data: {
      params: {
        pratica: id,
        esito,
        nota: nota || null,
      },
      method: 'conferma_controllo_senior_manager',
    },
  });

const annullaConfermaSenior = (id) =>
  request({
    url: RPC.GESTIONE_PRATICA,
    method: 'POST',
    data: {
      params: {
        pratica: id,
      },
      method: 'annulla_conferma_controllo_senior_manager',
    },
  });

const GestionePraticaService = {
  riassegnaPratica,
  confermaStipula,
  annullaConfermaStipula,
  forzaPraticaNonLiquidabile,
  forzaPraticaLiquidabile,
  getDatiCommissioning,
  getDatiCommissioningImpresa,
  blocca,
  GestioneAVCeDD,
  confermaSenior,
  annullaConfermaSenior,
};

export default GestionePraticaService;



// WEBPACK FOOTER //
// ./app/shared/services/rpc/gestione-pratica/index.js